import { z } from "zod";

import { configValueSchema } from "./configValue.ts";
import { variableConfigsSchema } from "./nodeConfigSchema.ts";
import { refsSchema } from "./refsSchema.ts";
import { ValueConfigs } from "./valueConfig.ts";

const ML = "__ml";

export const multilingualPropertySchema = z.record(z.string(), configValueSchema);

export const multilingualPropertiesSchema = z.object({
  [ML]: multilingualPropertySchema,
});

export type MultilingualProperty = z.infer<typeof multilingualPropertySchema>;

export type MultilingualProperties = z.infer<typeof multilingualPropertiesSchema>;

export type MultilingualConfigValue =
  | number
  | string
  | boolean
  | MultilingualConfigValue[]
  | { [name: string]: MultilingualConfigValue }
  | MultilingualProperties
  | null
  | undefined;

export const multilingualConfigValueSchema: z.ZodType<MultilingualConfigValue> = z.lazy(() =>
  z.union([
    z.number(),
    z.string(),
    z.boolean(),
    z.array(multilingualConfigValueSchema),
    multilingualPropertiesSchema,
    z.record(
      z.string().refine((v) => v !== ML), // otherwise multilingual values that are not strings get through
      multilingualConfigValueSchema,
    ),
    z.null(),
    z.undefined(),
  ]),
);

export const multilingualNodeConfigSchema = z
  .object({
    variables: variableConfigsSchema.optional(),
    nodeReferences: refsSchema.optional(),
    values: ValueConfigs.optional(),
  })
  .and(z.record(z.string(), multilingualConfigValueSchema));

export type MultilingualNodeConfig = z.infer<typeof multilingualNodeConfigSchema>;
